import { APIService } from "@/common/api.service";
import { dropdownOptions } from "./functions.module";
import {
  GET_CANDIDATE,
  GET_CANDIDATE_DATA,
  GET_CANDIDATE_DETAIL,
  GET_CANDIDATE_BY_SERIAL,
  CREATE_CANDIDATE_COMMENT,
  GET_COMMENTS_BY_CANDIDATE,
  GET_CANDIDATE_TO_ADD,
  UPDATE_CANDIDATE,
  CREATE_CANDIDATE,
  DOWNLOAD_CANDIDATE,
} from "./actions.type";
import {
  SET_CANDIDATE,
  SET_FILTERED_CANDIDATE,
  SET_CANDIDATE_DATA,
  SET_CANDIDATE_DETAIL,
  SET_CANDIDATE_BY_SERIAL,
  SET_CANDIDATE_COMMENTS,
  SET_CANDIDATE_TO_ADD,
} from "./mutations.type";

const state = {
  allCandidate: [],
  filteredCandidate: [],
  displayedCandidateData: null,
  candidatesBySerial: [],
  candidateList: {},
  candidateDetail: null,
  comments: [],
  candidateToAdd: [],
};

const getters = {
  candidate(state) {
    return state.allCandidate;
  },
  candidates(state) {
    return state.candidates;
  },
  filteredCandidate(state) {
    return state.filteredCandidate;
  },
  displayedCandidateData(state) {
    return state.displayedCandidateData;
  },
  candidatesBySerial(state) {
    return state.candidatesBySerial;
  },
  candidateList(state) {
    return state.candidateList;
  },
  candidateDetail(state) {
    return state.candidateDetail;
  },
  comments(state) {
    return state.comments;
  },
  candidateToAdd(state) {
    return dropdownOptions(state.candidateToAdd);
  },
};

const actions = {
  async [GET_CANDIDATE](context, searchFilter) {
    try {
      const { data } = await APIService.query("v3/users", searchFilter);
      context.commit(SET_CANDIDATE, data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DOWNLOAD_CANDIDATE](context, searchFilter) {
    try {
      const { data } = await APIService.query("v3/users", searchFilter);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  },
  // get data of a specific candidate

  async [GET_CANDIDATE_DATA](context, serialNumber) {
    try {
      const { data } = await APIService.get("/v3/user_data", serialNumber);
      context.commit(SET_CANDIDATE_DATA, data);
    } catch (error) {
      throw new Error(error);
    }
  },
  //get candidate and openseat details
  async [GET_CANDIDATE_DETAIL](context, id) {
    try {
      const { data } = await APIService.get("/v3/candidate/detail", id);
      context.commit(SET_CANDIDATE_DETAIL, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  //get candidates by serial number array.
  async [GET_CANDIDATE_BY_SERIAL](context, serialNumbers) {
    try {
      const { data } = await APIService.query(
        "/users/id/get-users-by-serial",
        serialNumbers
      );
      context.commit(SET_CANDIDATE_BY_SERIAL, data.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_COMMENTS_BY_CANDIDATE](context, ref_id) {
    try {
      const { data } = await APIService.get("/v3/candidate_comments", ref_id);

      context.commit(SET_CANDIDATE_COMMENTS, data.comments);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_CANDIDATE_COMMENT](context, data) {
    try {
      const comment = await APIService.post("/v3/candidate_comments", data);
      return comment.data.com;
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_CANDIDATE_TO_ADD](context, query) {
    try {
      const { data } = await APIService.get("/v3/user_to_add", query);

      context.commit(SET_CANDIDATE_TO_ADD, data.user);
      return data.user;
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_CANDIDATE](context, payload) {
    try {
      await APIService.update("/v3/candidates", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_CANDIDATE](context, payload) {
    try {
      const cand = await APIService.post("/v3/candidates", payload);
      return cand.data.candidate;
    } catch (error) {
      throw new Error(error);
    }
  },
};

const mutations = {
  [SET_CANDIDATE](state, candidate) {
    state.allCandidate = candidate.users;
    state.candidateList = candidate;
  },
  [SET_FILTERED_CANDIDATE](state, candidates) {
    state.filteredCandidate = candidates;
  },
  [SET_CANDIDATE_DATA](state, candidate) {
    state.displayedCandidateData = candidate;
  },
  [SET_CANDIDATE_DETAIL](state, candidate) {
    state.candidateDetail = candidate;
  },
  [SET_CANDIDATE_BY_SERIAL](state, candidatesBySerial) {
    state.candidatesBySerial = candidatesBySerial;
  },
  [SET_CANDIDATE_COMMENTS](state, comments) {
    state.comments = comments;
  },
  [SET_CANDIDATE_TO_ADD](state, candidateToAdd) {
    state.candidateToAdd = candidateToAdd;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
